import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const breadcrumbsRootFn = /* @__PURE__ */ createRecipe('breadcrumbs', {}, [])

const breadcrumbsRootVariantMap = {}

const breadcrumbsRootVariantKeys = Object.keys(breadcrumbsRootVariantMap)

export const breadcrumbsRoot = /* @__PURE__ */ Object.assign(memo(breadcrumbsRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'breadcrumbsRoot',
  __getCompoundVariantCss__: breadcrumbsRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: breadcrumbsRootVariantKeys,
  variantMap: breadcrumbsRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, breadcrumbsRootVariantKeys)
  },
  getVariantProps: breadcrumbsRootFn.getVariantProps,
})